var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6504 10.1567H13.4374C12.2577 10.156 11.3015 9.19154 11.3008 8.00073C11.3008 6.80993 12.2577 5.84546 13.4374 5.84473H16.6504",
    stroke: "#ffbb00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8017 7.95148H13.5544",
    stroke: "#ffbb00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62575 1.02759H12.4856C14.7857 1.02759 16.6504 2.9098 16.6504 5.23154V10.9811C16.6504 13.3029 14.7857 15.1851 12.4856 15.1851H5.62575C3.32563 15.1851 1.46094 13.3029 1.46094 10.9811V5.23154C1.46094 2.9098 3.32563 1.02759 5.62575 1.02759Z",
    stroke: "#ffbb00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.06055 4.66315H9.34543",
    stroke: "#ffbb00",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/Wallet.3f30987bff905fd5c064fe9893bf3b28.svg";
export { ForwardRef as ReactComponent };